import React, { Component } from "react";
import { Query, Mutation } from "react-apollo";
import gql from "graphql-tag";
import { Button, Container, Header } from "semantic-ui-react";

import { CATEGORIES_QUERY } from "../../graphql/queries";
import CategoryForm from "./CategoryForm";
import Category from "./Category";
import { withApplicationId, withLanguage } from 'HOCs'

class CategoriesList extends Component {
  state = {
    newCategoryFormVisibility: false
  };
  showCategoryForm = () => {
    this.setState({ newCategoryFormVisibility: true });
  };
  hideCategoryForm = () => {
    this.setState({ newCategoryFormVisibility: false });
  };
  render() {
    const {applicationId, language} = this.props
    return (
      <Container>
        <Header as="h1">Categories</Header>
        <Query
          query={CATEGORIES_QUERY}
          variables={{ language, applicationId }}
          fetchPolicy="network-only"
        >
          {({ data, loading, error }) => {
            if (loading) {
              return <p>loading...</p>;
            }
            if (error) {
              return <p>error</p>;
            }
            return (
              <div>
                {this.state.newCategoryFormVisibility ? (
                  <Mutation
                    mutation={CREATE_CATEGORY}
                    update={(cache, { data }) => {
                      const { categories } = cache.readQuery({
                        query: CATEGORIES_QUERY,
                        variables: {
                          language,
                          applicationId
                        }
                      });
                      cache.writeQuery({
                        query: CATEGORIES_QUERY,
                        variables: {
                          language,
                          applicationId
                        },
                        data: {
                          categories: [...categories, data.createCategory]
                        }
                      });
                    }}
                  >
                    {(
                      createCategory,
                      { loading: createLoading, error: createError }
                    ) => {
                      const addCategory = input =>
                        createCategory({
                          variables: { language, input: {...input, applicationId} }
                        });
                      return (
                        <CategoryForm
                          hide={this.hideCategoryForm}
                          submit={addCategory}
                          loading={createLoading}
                          defaultImages={data.categories.map(category => category.iconUrl)}
                        />
                      );
                    }}
                  </Mutation>
                ) : (
                  <Button primary onClick={this.showCategoryForm}>
                    Add New Category
                  </Button>
                )}

                {data.categories.map(category => {
                  return (
                    <Mutation
                      mutation={UPDATE_CATEGORY}
                      key={category.id}
                      update={(cache, { data }) => {
                        const { categories } = cache.readQuery({
                          query: CATEGORIES_QUERY,
                          variables: {
                            language,
                            applicationId
                          }
                        });
                        cache.writeQuery({
                          query: CATEGORIES_QUERY,
                          variables: {
                            language,
                            applicationId
                          },
                          data: {
                            categories: categories.map(category =>
                              category.id === data.updateCategory.id
                                ? data.updateCategory
                                : category
                            )
                          }
                        });
                      }}
                    >
                      {(
                        updateCategory,
                        { loading: updateLoading, error: updateError }
                      ) => (
                        <Mutation
                          mutation={DELETE_CATEGORY}
                          update={(cache, { data: { deleteCategory } }) => {
                            const { categories } = cache.readQuery({
                              query: CATEGORIES_QUERY,
                              variables: {
                                language,
                                applicationId
                              }
                            });
                            cache.writeQuery({
                              query: CATEGORIES_QUERY,
                              variables: {
                                language,
                                applicationId
                              },
                              data: {
                                categories: categories.filter(
                                  category => category.id !== deleteCategory.id
                                )
                              }
                            });
                          }}
                        >
                          {(
                            deleteCategory,
                            { loading: deleteLoading, error: deleteError }
                          ) => {
                            const edit = input =>
                              updateCategory({
                                variables: {
                                  language,
                                  id: category.id,
                                  input: { ...input, applicationId}
                                }
                              });
                            const remove = () =>
                              deleteCategory({
                                variables: {
                                  language,
                                  id: category.id
                                }
                              });
                            return (
                              <Category
                                key={category.id}
                                id={category.id}
                                name={category.name}
                                description={category.description}
                                iconUrl={category.iconUrl}
                                order={category.order}
                                delete={remove}
                                update={edit}
                                deleteLoading={deleteLoading}
                                updateLoading={updateLoading}
                                defaultImages={data.categories.map(category => category.iconUrl)}
                              />
                            );
                          }}
                        </Mutation>
                      )}
                    </Mutation>
                  );
                })}
              </div>
            );
          }}
        </Query>
      </Container>
    );
  }
}

export const CREATE_CATEGORY = gql`
  mutation CreateCategory($language: String!, $input: CreateCategoryInput!) {
    createCategory(language: $language, input: $input) {
      id
      name
      iconUrl
      description
      applicationId
      order
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UpdateCategory(
    $language: String!
    $id: ID!
    $input: UpdateCategoryInput!
  ) {
    updateCategory(language: $language, id: $id, input: $input) {
      id
      name
      iconUrl
      description
      applicationId
      order
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation DeleteCATEGORY($language: String!, $id: ID!) {
    deleteCategory(language: $language, id: $id) {
      id
    }
  }
`;

export default withApplicationId(withLanguage(CategoriesList));



// WEBPACK FOOTER //
// ./src/pages/Categories/index.js